import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { Mail, MailOpen, Trash2 } from 'lucide-react';

interface Message {
  id: string;
  name: string;
  email: string;
  phone: string;
  message: string;
  is_read: boolean;
  created_at: string;
}

const MessagesAdmin = () => {
  const [messages, setMessages] = useState<Message[]>([]);

  const fetchMessages = async () => {
    const { data } = await supabase.from('contact_messages').select('*').order('created_at', { ascending: false });
    if (data) setMessages(data);
  };

  useEffect(() => { fetchMessages(); }, []);

  const toggleRead = async (id: string, current: boolean) => {
    await supabase.from('contact_messages').update({ is_read: !current }).eq('id', id);
    setMessages(prev => prev.map(m => m.id === id ? { ...m, is_read: !current } : m));
  };

  const deleteMessage = async (id: string) => {
    await supabase.from('contact_messages').delete().eq('id', id);
    toast.success('Smazáno');
    fetchMessages();
  };

  return (
    <div>
      <h1 className="text-4xl tracking-wider text-foreground mb-8" style={{ fontFamily: 'Bebas Neue' }}>
        Zprávy
      </h1>

      <div className="space-y-3">
        {messages.map((msg) => (
          <div key={msg.id} className={`p-4 bg-card border rounded-md transition-colors ${msg.is_read ? 'border-border' : 'border-primary/30 bg-primary/5'}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className="font-medium text-foreground">{msg.name}</span>
                  <span className="text-sm text-muted-foreground">{msg.email}</span>
                  {msg.phone && <span className="text-sm text-muted-foreground">📞 {msg.phone}</span>}
                </div>
                <p className="text-foreground text-sm whitespace-pre-wrap">{msg.message}</p>
                <p className="text-xs text-muted-foreground mt-2">{new Date(msg.created_at).toLocaleString('cs-CZ')}</p>
              </div>
              <div className="flex gap-2">
                <button onClick={() => toggleRead(msg.id, msg.is_read)} className="p-2 text-muted-foreground hover:text-primary transition-colors">
                  {msg.is_read ? <MailOpen size={18} /> : <Mail size={18} />}
                </button>
                <button onClick={() => deleteMessage(msg.id)} className="p-2 text-muted-foreground hover:text-destructive transition-colors">
                  <Trash2 size={18} />
                </button>
              </div>
            </div>
          </div>
        ))}
        {messages.length === 0 && (
          <p className="text-center text-muted-foreground py-12">Zatím žádné zprávy.</p>
        )}
      </div>
    </div>
  );
};

export default MessagesAdmin;
